/**
 * @generated SignedSource<<27f84f6b0304813cd49313a5340eabde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorSettingsMenuCatering_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_package">;
  readonly " $fragmentType": "RoomRatesEditorSettingsMenuCatering_package";
};
export type RoomRatesEditorSettingsMenuCatering_package$key = {
  readonly " $data"?: RoomRatesEditorSettingsMenuCatering_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenuCatering_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorSettingsMenuCatering_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorCateringSettings_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "6004e3194f18c89c4dcf0872934e5403";

export default node;
